import { VIP_TYPE } from '../composables/constants'

const CYCLE_DAYS: Record<number, number> = {
  6: 1, // OneDay
  7: 3, // ThreeDays
  1: 7, // WEEK
  2: 30, // MONTH
  3: 90, // SEASON
  4: 182, // HALF_YEAR
  5: 365, // YEAR
}

export function shouldShowDailyPrice(item: any, isZero: (v: any) => boolean): boolean {
  if (!item || item.subscribeType === VIP_TYPE.DISCOUNT)
    return false
  if (!item.preferentialPrice || isZero(item.preferentialPrice))
    return false
  const p = Number(item.preferentialPrice)
  const o = Number(item.price)
  if (!o || !p || p >= o)
    return false
  if (!CYCLE_DAYS[item.cycle])
    return false
  return true
}

export function getDailyPrice(item: any): string {
  const days = CYCLE_DAYS[item.cycle] || 1
  return (Number(item.preferentialPrice) / days).toFixed(2)
}

export function getSavePercent(item: any): number {
  const p = Number(item.preferentialPrice)
  const o = Number(item.price)
  if (!o || !p || p >= o)
    return 0
  return Math.round((1 - p / o) * 100)
}
